import { ConsentUpdate, Purpose } from '@mfe/types/model';

// transform for POST ConsentUpdateList
// but only not granted consents should be saved
export const transformConsents4Save = (actualConsents: Purpose[]): ConsentUpdate[] => actualConsents
  .flatMap((purpose) => purpose.subscriptions
    .flatMap((subscription) => subscription.apps
      .filter((app) => !app.granted).map((app) => ({
        id: app.id,
        status: 'revoked',
      }))));
